import {createApp} from "vue";
import GroupSettingsView from "./src/components/group/GroupSettingsView";

const groupSettingsApp = createApp({});

groupSettingsApp.component('group-settings-view', GroupSettingsView);

groupSettingsApp.mount('#group-settings-component');
